import { render, staticRenderFns } from "./FileSelectionDialog.vue?vue&type=template&id=53d2d265"
import script from "./FileSelectionDialog.vue?vue&type=script&lang=js"
export * from "./FileSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports